









































































































import { BSidebar,
  BForm,
  BButton,
  BCard,
  BCol,
  BFormCheckbox,
  BFormRadio,
  BDropdown,
  BFormGroup,
  BDropdownItem,
  BFormInput,
  BPagination,
  BRow,
  BTable,
  BSpinner,
  BFormTextarea
} from 'bootstrap-vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import { PaginatedList } from '@/api/models/common/paginatedList';
import { errorAlert, successAlert } from '@/libs/sweetAlerts/alerts';
import { ExportDonneeCreateModel } from '@/api/models/exportDonnees/export';

@Component({
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BTable,
    BPagination,
    BDropdown,
    BDropdownItem,
    BSidebar, 
    BForm,
    BFormGroup,
    BFormCheckbox,
    BFormRadio,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    SearchableVueSelect,
    BFormTextarea
  },
  name: "create-export"
})
export default class CreateExport extends Vue {
  @Prop({ required: true, type: Boolean }) isAddNewExportDonneeSidebarActive!: boolean
  loading = false

  required = required;
  
  newExportDonnee: ExportDonneeCreateModel = {}
  listSecteursActivite = new PaginatedList<any>()

  resetForm() {
    this.newExportDonnee = {}
  }

  async submit() {
    this.loading = true
    await this.$http.myressif.exportDonnees.post(this.newExportDonnee)
      .then(
        async (response: any) => {
            successAlert.fire({
              timer: 3500,
              title: "Création d'un fournisseur",
              text: "Export créé dans MyRessif avec succès",
            });
          },     
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.$emit('refetch-data')
        this.$emit('update:is-add-new-export-sidebar-active', false)
        this.loading = false
      }); ;
  } 
}
